// extracted by mini-css-extract-plugin
export default {"tag-offset":"tag-offset__Lg86s"};